import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import c from './assets/sass/banner.module.scss'

import { useEffect, useState } from 'react'
import { apiClient } from 'core/http'
import { toast } from 'react-toastify'

export const Banner = () => {
    const { t } = useTranslation()
    const [friendsCount, setFriendsCount] = useState(null)
    const [rewardNext, setRewardNext] = useState(null)
    const [progress, setProgress] = useState(0)
    const [code, setCode] = useState('')
    const [remaining, setRemaining] = useState(3)

    const loadData = async () => {
        try {
            const [friendsRes, codeRes] = await Promise.all([
                apiClient.get('/friends'),
                apiClient.get('/friends/referral-code'),
            ])
            if (friendsRes?.data?.success) {
                const total =
                    friendsRes.data.stats?.total ??
                    friendsRes.data.friends?.length ??
                    0
                setFriendsCount(total)

                const currentLevel = friendsRes.data.stats?.currentLevel
                const nextLevel =
                    friendsRes.data.stats?.nextLevel ||
                    friendsRes.data.stats?.nextMilestone

                if (nextLevel) {
                    setRewardNext(
                        nextLevel.rewardPerReferral
                            ? Number(nextLevel.rewardPerReferral)
                            : nextLevel.reward
                              ? Number(nextLevel.reward)
                              : null
                    )

                    const currentRequired = currentLevel?.requiredReferrals || 0
                    const nextRequired =
                        nextLevel.requiredReferrals || nextLevel.threshold || 0
                    const range = nextRequired - currentRequired
                    const cur = Math.max(0, total - currentRequired)
                    setProgress(Math.min(100, Math.floor((cur / range) * 100)))
                    setRemaining(Math.max(0, nextRequired - total))
                } else {
                    setRewardNext(null)
                    setProgress(100)
                    setRemaining(0)
                }
            }
            if (codeRes?.data?.referralCode) {
                setCode(codeRes.data.referralCode)
            }
        } catch (e) {}
    }

    useEffect(() => {
        loadData()

        const interval = setInterval(() => {
            loadData()
        }, 5000)

        return () => clearInterval(interval)
    }, [])

    return (
        <div className={c.component}>
            <div className={c.row}>
                <div className={c.top}>
                    <div className={cn(c.counter, c.friends)}>
                        <span className={c.number}>{friendsCount ?? 49}</span>
                        <span className={c.title}>
                            {t('friends.banner.friends')}
                        </span>
                    </div>
                    <div className={cn(c.counter, c.reward)}>
                        <span className={c.number}>
                            {rewardNext ? `+${Number(rewardNext)}` : '+90'}
                        </span>
                        <span className={c.title}>
                            {t('friends.banner.reward')}
                            <br />
                            <span style={{ fontSize: '10px', opacity: 0.7 }}>
                                {t('friends.banner.perReferral')}
                            </span>
                        </span>
                    </div>
                </div>
                <div className={c.progress}>
                    <div className={c.bar}>
                        <div
                            className={c.line}
                            style={{ width: `${progress}%` }}
                        ></div>
                    </div>
                    <span>
                        {friendsCount !== null && remaining >= 0
                            ? t('friends.banner.remaining', {
                                  count: remaining,
                              })
                            : t('friends.banner.remainingDefault')}
                    </span>
                </div>
                <div className={c.code}>
                    <div className={c.codeText}>
                        <span className={c.referral}>{code || '12345678'}</span>
                        <span className={c.codeTitle}>
                            {t('friends.banner.referralLink')}
                        </span>
                    </div>
                    <button
                        className={c.button}
                        onClick={async () => {
                            const BOT_USERNAME = 'gg_funny_bot'
                            const deepLink = `https://t.me/${BOT_USERNAME}?startapp=${code}`
                            const text = t('friends.banner.shareText')
                            
                            // Пробуем новый способ с prepared message (картинка + кнопка)
                            try {
                                // Получаем текущий язык
                                const currentLang = window.localStorage.getItem('i18nextLng') || 'ru'
                                
                                // Проверяем поддержку shareMessage (Telegram WebApp v8.0+)
                                const webApp = window?.Telegram?.WebApp
                                if (webApp?.shareMessage && webApp?.version && parseFloat(webApp.version) >= 8.0) {
                                    // Запрашиваем prepared message с бэкенда
                                    const response = await apiClient.post('/friends/prepare-share', {
                                        language: currentLang
                                    })
                                    
                                    if (response?.data?.success && response?.data?.preparedMessageId) {
                                        // Используем новый API shareMessage
                                        webApp.shareMessage(response.data.preparedMessageId, (sent) => {
                                            if (sent) {
                                                toast(t('friends.banner.linkCopied'), { type: 'success' })
                                            }
                                        })
                                        return
                                    }
                                }
                            } catch (prepareError) {
                                console.log('prepareShare fallback:', prepareError?.message)
                            }
                            
                            // Fallback на старый способ (ссылка + текст)
                            const shareLink = `https://t.me/share/url?url=${encodeURIComponent(deepLink)}&text=${encodeURIComponent(text)}`

                            try {
                                if (
                                    window?.Telegram?.WebApp?.openTelegramLink
                                ) {
                                    window.Telegram.WebApp.openTelegramLink(
                                        shareLink
                                    )
                                    return
                                }
                                const w = window.open(shareLink, '_blank')
                                if (!w) {
                                    await navigator.clipboard.writeText(
                                        `${text}\n${deepLink}`
                                    )
                                    toast(t('friends.banner.linkCopied'), {
                                        type: 'success',
                                    })
                                }
                            } catch (_) {
                                try {
                                    await navigator.clipboard.writeText(
                                        `${text}\n${deepLink}`
                                    )
                                    toast(t('friends.banner.linkCopied'), {
                                        type: 'success',
                                    })
                                } catch {}
                            }
                        }}
                    >
                        <span>{t('friends.banner.share')}</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
